import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { METADATA } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

export const MembersResolver = () => {
  
  const dispatch = useDispatch();

  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1]; 
  const params = useParams();
  const metadata = useSelector((state: any) => state.metadata);

  async function init() {
    const COMMUNITY_ID = pathSegment === 'community' ? params.id : null;

    if (!COMMUNITY_ID) {
      return;
    }
   
    // Token auto-injected by httpService interceptor
    dispatch(METADATA.SetMembersAsync({dispatch, COMMUNITY_ID}) as any);

    // try {
      
    // globalSetFiltersStore({
    //   type: FiltersStoreTypes.SetFilteredMembers,
    //   payload: {
    //     value: members
    //   }
    // })
    // } catch (err: any) {
    //   console.warn(err);
    // }
  }

  useEffect(() => {
      init();
  }, [params.id]);

  return <></>;
};
